module.exports = __webpack_public_path__ + "static/media/Dickenson.4d9c2f37.png";